<template>
    <v-avatar :size="avatarSize">
      <v-img v-if="image" :src="image" :size="iconSize"></v-img>
      <v-icon v-else :color="color" :size="iconSize">{{ icon }}</v-icon>
    </v-avatar>
</template>
<script>
import { getIcon, getIconColor, settings } from '@/js/store'
import { SearchUtils } from '@/js'
export default {
  props: {
    award: Object
  },
  name: 'Awardblob',
  computed: {
    avatarSize () {
      return this.iconSize + 4
    },
    iconSize () {
      return settings.dimensions.blobIconSm - 8
    },
    iconType () {
      return 'award'
    },
    icon () {
      return getIcon(this.iconType)
    },
    color () {
      return getIconColor(this.iconType)
    },
    image () {
      return SearchUtils.getImageFromAward({ award: this.award })
    }
  }
}
</script>
